var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"video-preview"},[_c('b-embed',{staticClass:"video-preview",attrs:{"type":"iframe","src":_vm.embed,"allowfullscreen":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }